(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-product-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-product-extras')) {
  customElements.define('ms-product-extras', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mainForm = document.getElementById(this.dataset.mainForm);
      this.parentPrice = Number(this.dataset.parentPrice);
      this.parentAvailable = this.dataset.parentAvailable === 'true';
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-frame-choice]');
        if (choice && !choice.disabled) this.chooseFrame(choice);
        if (event.target.closest('[data-no-frame]')) this.chooseFrame(null);
        if (event.target.closest('[data-buy-bundle]')) this.addBundle();
      }, {signal});
      this.mainForm?.addEventListener('change', event => {
        if (event.target.name === 'quantity') this.updateBundle();
      }, {signal});
      document.addEventListener('change', event => {
        if (event.target.matches('input[data-option-position]') && event.target.form === this.mainForm) {
          this.variantPending = true;
          this.chooseFrame(null);
          this.matchShoeExtras(null);
        }
      }, {capture:true, signal});
      this.addEventListener('change', event => {
        if (event.target.matches('select[name="id"]')) {
          const card = event.target.closest('[data-extra-card]');
          card.querySelector('[data-extra-price]').textContent = event.target.selectedOptions[0].dataset.price;
          this.querySelector('[data-extra-status]').textContent = '';
        }
      }, {signal});
      this.addEventListener('submit', event => {
        const card = event.target.closest('[data-shoe-fit]');
        if (card && (card.hidden || this.variantPending || event.target.elements.id?.value !== card.dataset.matchedVariant)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, {capture:true, signal});
      this.addEventListener('variant:add', () => {
        this.querySelector('[data-extra-status]').textContent = this.dataset.addedMessage;
      }, {signal});
      this.addEventListener('cart:error', event => {
        this.querySelector('[data-extra-status]').textContent = event.detail?.error || this.dataset.errorMessage;
      }, {signal});
      this.mainForm?.addEventListener('variant:change', event => {
        this.matchFrames(event.detail.variant);
        this.matchShoeExtras(event.detail.variant?.options?.[Number(this.dataset.shoeSizePosition)]);
      }, {signal});
      this.matchShoeExtras(this.dataset.selectedShoeSize);
      this.updateEmptyState();
    }
    matchShoeExtras(value) {
      const numeric = String(value || '').trim().match(/^(?:EU\s*)?(\d+(?:[.,]\d+)?)\s*(?:EU)?$/i);
      const size = this.dataset.shoeSizePosition !== '' && numeric ? Number(numeric[1].replace(',', '.')) : null;
      this.querySelectorAll('[data-shoe-fit]').forEach(card => {
        const variants = JSON.parse(card.querySelector('[data-extra-variants]').textContent);
        const selected = size !== null && variants.find(variant => {
          const range = variant.title.match(/\((\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)\)/);
          return range && size >= Number(range[1].replace(',', '.')) && size <= Number(range[2].replace(',', '.'));
        });
        card.hidden = !selected;
        card.dataset.matchedVariant = selected ? String(selected.id) : '';
        const input = card.querySelector('[name="id"]');
        if (input.tagName === 'SELECT') {
          [...input.options].forEach(option => {
            if (!option.value) return;
            option.disabled = option.value !== card.dataset.matchedVariant;
            option.hidden = option.disabled;
          });
        }
        input.value = card.dataset.matchedVariant;
        input.disabled = !selected;
        card.querySelector('[type="submit"]').disabled = !selected;
        if (selected) card.querySelector('[data-extra-price]').textContent = selected.price;
      });
    }
    dimension(value) {
      const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
      return match ? match.slice(1).map(number => Number(number.replace(',', '.'))).sort((a,b) => a-b).join('x') : null;
    }
    matchFrames(variant) {
      this.variantPending = false;
      this.parentPrice = Number(variant?.price || 0);
      this.parentAvailable = Boolean(variant?.available);
      this.chooseFrame(null);
      const dimension = variant?.options?.map(value => this.dimension(value)).find(Boolean);
      this.querySelectorAll('[data-frame-match]').forEach(card => {
        const variants = JSON.parse(card.querySelector('[data-extra-variants]').textContent);
        const selected = dimension && variants.find(item => item.options.some(value => this.dimension(value) === dimension));
        card.hidden = !selected;
        const choice = card.querySelector('[data-frame-choice]');
        choice.dataset.variantId = selected?.id || '';
        choice.dataset.price = selected?.amount || '';
        choice.disabled = !selected;
        if (selected) {
          card.querySelector('[data-extra-size]').textContent = selected.title;
          card.querySelector('[data-extra-price]').textContent = selected.price;
        }
      });
      this.querySelector('[data-extra-status]').textContent = '';
      this.updateEmptyState();
    }
    chooseFrame(choice) {
      this.selectedFrame = choice;
      this.querySelectorAll('[data-frame-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
      this.querySelector('[data-no-frame]')?.setAttribute('aria-pressed', String(!choice));
      this.updateBundle();
    }
    updateBundle() {
      const button = this.querySelector('[data-buy-bundle]');
      if (!button) return;
      button.hidden = !this.selectedFrame;
      button.disabled = !this.parentAvailable || this.variantPending || this.busy;
      if (!this.selectedFrame) return;
      const quantity = Math.max(1, Number(this.mainForm?.elements.quantity?.value || 1));
      const amount = (this.parentPrice + Number(this.selectedFrame.dataset.price)) * quantity / 100;
      const total = new Intl.NumberFormat(this.dataset.locale || 'sv', {style:'currency',currency:this.dataset.currency || 'SEK'}).format(amount);
      this.querySelector('[data-bundle-text]').textContent = `${this.dataset.bundleLabel} · ${total}`;
    }
    async addBundle() {
      const button = this.querySelector('[data-buy-bundle]');
      if (this.busy || this.variantPending || !this.parentAvailable || !this.selectedFrame || !this.mainForm?.reportValidity()) return;
      const mainId = Number(this.mainForm.elements.id.value);
      const frameId = Number(this.selectedFrame.dataset.variantId);
      if (!mainId || !frameId || this.selectedFrame.disabled) return;
      this.busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const status = this.querySelector('[data-extra-status]');
      status.textContent = '';
      const quantity = Math.max(1, Number(this.mainForm.elements.quantity?.value || 1));
      const properties = {};
      for (const [key, value] of new FormData(this.mainForm)) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      }
      const sections = new Set();
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true,detail:{sections}}));
      const root = window.Shopify.routes.root;
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({items:[{id:mainId,quantity,properties},{id:frameId,quantity}],sections:[...sections].slice(0,5)})
        });
        const result = await response.json();
        if (!response.ok) {
          status.textContent = result.description || result.message || this.dataset.bundleError;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
          return;
        }
        added = true;
        if (window.themeVariables.settings.cartType === 'page') { window.location.assign(`${root}cart`); return; }
        const cartResponse = await fetch(`${root}cart.js`);
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        this.mainForm.dispatchEvent(new CustomEvent('variant:add', {bubbles:true,detail:{items:result.items,cart}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true,detail:{baseEvent:'variant:add',cart}}));
        status.textContent = this.dataset.bundleAdded;
        this.chooseFrame(null);
      } catch {
        if (added) { window.location.assign(`${root}cart`); return; }
        status.textContent = this.dataset.bundleError;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
      } finally {
        this.busy = false;
        button.disabled = !this.parentAvailable || this.variantPending;
        button.removeAttribute('aria-busy');
      }
    }
    updateEmptyState() {
      const empty = this.querySelector('[data-no-matching-frame]');
      if (empty) empty.hidden = [...this.querySelectorAll('[data-extra-card]')].some(card => !card.hidden);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    function msSizeKey(value) {
  const text = String(value).trim().toLowerCase().replace(/,/g, '.');
  const dimension = text.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
  if (dimension) {
    const sides = dimension.slice(1).map(Number).sort((a, b) => a - b);
    return [0, sides[0] * sides[1], ...sides];
  }
  const letters = text.split(/[ (\/]/)[0].replace(/-/g, '');
  const names = {xxsmall:-2, xsmall:-1, small:0, medium:1, large:2, xlarge:3, xxlarge:4, s:0, m:1, l:2};
  if (Object.hasOwn(names, letters)) return [1, names[letters]];
  const alpha = letters.match(/^(\d+x?|x+)(s|l)$/);
  if (alpha) {
    const count = /^\d/.test(alpha[1]) ? parseInt(alpha[1], 10) : alpha[1].length;
    return [1, alpha[2] === 's' ? -count : 2 + count];
  }
  const numeric = text.match(/^(?:(?:eu|uk|us)\s*)?(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+)|\s*([½⅓⅔¼¾]))?/);
  if (numeric) {
    const fractions = {'½':0.5,'⅓':1/3,'⅔':2/3,'¼':0.25,'¾':0.75};
    return [0, Number(numeric[1]) + (numeric[2] ? Number(numeric[2]) / Number(numeric[3]) : fractions[numeric[4]] || 0)];
  }
  return [2, text];
}
function msCompareSizes(a, b) {
  const left = msSizeKey(a), right = msSizeKey(b);
  for (let i = 0; i < Math.max(left.length, right.length); i++) {
    if (left[i] === right[i]) continue;
    if (typeof left[i] === 'number' && typeof right[i] === 'number') return left[i] - right[i];
    return String(left[i] || '').localeCompare(String(right[i] || ''), 'sv', {numeric:true, sensitivity:'base'});
  }
  return 0;
}
if (!customElements.get('ms-size-options')) {
  customElements.define('ms-size-options', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('sort-sizes')) return;
      const sort = () => {
        const list = this.querySelector('select') || this;
        const selected = list.tagName === 'SELECT' ? list.value : null;
        const children = [...list.children].filter(child => child.hasAttribute('data-size-value'));
        const sorted = [...children].sort((a, b) => msCompareSizes(a.dataset.sizeValue, b.dataset.sizeValue));
        if (sorted.some((child, index) => child !== children[index])) {
          sorted.forEach(child => list.append(child));
          if (selected !== null) list.value = selected;
        }
      };
      this.observer = new MutationObserver(sort);
      this.observer.observe(this, {childList:true, subtree:true});
      sort();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
